/* eslint-disable */
import _ from 'lodash';

const getters = {
  rolePermissions: (state) => state.rolePermissions,
  rolesList: (state) => Object.keys(state.rolePermissions),
  roleHasPermission: (state) => ({ role, permissions }) => {
    // action : possession : entity
    return permissions.some((perm) => {
      const entity = perm.split(':')[2];
      if (!entity) return false;
      const permission = perm.replace(`:${entity}`, '');
      return _.get(state, `rolePermissions.${role}.${entity}.${permission}`, false);
    });
  },
  currentUserHasPermission: (state, _getters, rootState, rootGetters) => (permissions) => {
    const role = rootGetters['auth/authenticatedUserRole'];
    return getters.roleHasPermission(state)({ role, permissions });
  },
};

export default getters;
